module.exports = __webpack_public_path__ + "img/149.0990c41c.jpg";